import globalConfig from "./global-variables";

const rocketChatConfig = {
    API_URL: '',
    password: ''
}

switch (globalConfig.env) {
    case 'staging':
        rocketChatConfig.API_URL = "https://samsungmcs.site:8443";
        break;
    case 'prod':
        rocketChatConfig.API_URL = "https://scsi.sec.samsung.net:8443";
        break;

    case 'origin':
        rocketChatConfig.API_URL = `${location.origin}:8443`;
        break;
}

export default rocketChatConfig;
